import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import '../../../Assets/css/mjstatic.css';
import { useSelector } from 'react-redux';
import { client_name } from '../../../Helpers/request';

const ReturnsExchanges = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>
      <div className="rcs_returns_exchanges_banner"></div>
      <Container>
        <Row>
          <Col sm={12}>
            <div className="rcs_free_diamond_content mt-5 mb-5">
              <h1>RETURN & EXCHANGE POLICY</h1>
              <p className="mt-5 text-center">
                Alicia's Jewelers ensures a risk-free online shopping experience with the guaranteed assurance of our return policy. Your satisfaction is our priority, and if, for any reason, you are not pleased with your purchase, you can return any item without custom engraving or sizing in its original condition for a refund or an exchange. Refunds will be credited in the same form as the
                original payment.
              </p>
              <p className="text-center">Our standard refund/return policy covers Premier Pre-Owned watches, subject to inspection before issuing a refund.</p>
              <p className="text-center">Please note that some limits apply to Special Order items and special-size items (such as rings), so contact us for specific details.</p>
              <p className="text-center">
                Returns must be initiated within 14 days from the date of purchase. The shipping fee is non-refundable, and return shipping charges will only be refunded in the case of discrepancies and errors on the part of Alicia's Jewelers. We only refund up to the price of "standard ground" shipping. To confirm any shipping requests, please email us before placing your order.
              </p>
              <h5 className="text-center">IN-STORE REFUND/RETURN POLICY</h5>
              <p className="text-center">
                For in-store purchases, merchandise may be returned for exchange or store credit within 14 days from the date of purchase, with the original sales receipt required. Items must be in their original condition and presented with all packaging materials. Gift receipts will only be issued merchandise credit. Special orders are considered final sales, as are layaways, which must be paid
                in full. No cash refunds are provided.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ReturnsExchanges;
